import * as React from "react";
import * as kea from "kea-react";
import * as selectores from "app/features/selectores/index";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { RutaSucursalTrasbordoDTO } from "app/models/requireme";

type Entity = RutaSucursalTrasbordoDTO;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un RutaSucursal
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        IdSucursal: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un RutaSucursal
*/
export class RutaSucursalTrasbordoEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelectorRx(this.value, x => validar(x));
    hasError = createSelectorRx(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;

        const Sucursal = getField(selectores.Sucursal);
        const Check = getField(kea.Checkbox);

        const hasError = this.hasError(this.props);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Editar sucursal de trasbordo"
            >

                {kea.autogrid(6, [
                    <Sucursal field="IdSucursal" label="Segmento" />,
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/rutas/edit/trasbordos/edit.tsx